// extracted by mini-css-extract-plugin
export default {"Wrapper":"SiteError_Wrapper__6PZfL","Box":"SiteError_Box__gt0K9"};